'use client';

import { useEffect, useState } from 'react';

import { getWindowTrackerState } from '../utils';
import { EVENT_TRACKER_READY } from '../utils/event-names';

type UseIsTrackerReady = () => boolean;

/**
 * Checks if the tracker is ready.
 */
export const useIsTrackerReady: UseIsTrackerReady = () => {
  const [trackerReady, setTrackerReady] = useState(false);

  const handleTrackerReadyStateChange = () => {
    setTrackerReady(true);
  };

  useEffect(() => {
    if (getWindowTrackerState().ready) {
      return;
    }

    window.addEventListener(EVENT_TRACKER_READY, handleTrackerReadyStateChange);

    return () => {
      window.removeEventListener(
        EVENT_TRACKER_READY,
        handleTrackerReadyStateChange,
      );
    };
  }, []);

  if (getWindowTrackerState().ready) {
    return true;
  }

  return trackerReady;
};
